import { Link } from "react-router-dom";
import { CheckCircle, Download, WhatsappLogo } from "@phosphor-icons/react";
import { siteSettings } from "@/content/site";

export default function GrazieSopralluogo() {
  const wa = siteSettings.whatsapp_number?.replace(/[^\d]/g, "");

  return (
    <div className="min-h-screen bg-warm-white flex items-center justify-center px-5">
      <div className="max-w-xl text-center">
        <CheckCircle size={64} weight="light" className="text-oasi-green mx-auto mb-6" />
        <div className="overline mb-3">Richiesta ricevuta</div>
        <h1 className="font-display text-4xl md:text-5xl mb-5">Richiesta ricevuta.</h1>
        <p className="text-[#5C5C59] text-base md:text-lg leading-relaxed mb-8">Grazie, abbiamo ricevuto la tua richiesta. Ti ricontatteremo per raccogliere le ultime informazioni e valutare insieme il sopralluogo.</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {wa && (
            <a href={`https://wa.me/${wa}`} target="_blank" rel="noopener noreferrer" className="btn-primary inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full text-sm">
              <WhatsappLogo size={18} weight="fill" /> Scrivici su WhatsApp
            </a>
          )}
          <Link to="/guida-ristrutturazione-bagno" className="btn-outline inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full text-sm">
            <Download size={18} /> Scarica anche la guida gratuita
          </Link>
        </div>
        <Link to="/" className="block mt-8 text-xs text-[#5C5C59] underline">Torna alla homepage</Link>
      </div>
    </div>
  );
}
